export function toDegrees(angle) {
	return angle * (180 / Math.PI);
}

export function toRadians(angle) {
	return angle * (Math.PI / 180);
}
